module.exports = __webpack_public_path__ + "9af163072f69edf9c39fd826a4d08c31.svg";